import axios from "axios";
import api from "@/store/modules/api";

export default {
  state: {
    data: [{_id: undefined, project_name: '', steps: []}],
    is_edit_mode: false,
    selected_project_id: undefined,
  },
  mutations: {
    SET_ROADMAPS_STATE (state, {key, value}) {
      state[key] = value;
    },
    UPDATE_STEP (state, {project_id = '', step_data}) {
      const project_idx = state.data.findIndex(project => project._id === project_id);
      const step_idx = state.data[project_idx].steps.findIndex(step => step._id === step_data._id);
      state.data[project_idx].steps[step_idx] = { ...step_data };
    },
    ADD_PROJECT_STEP (state, step_data) {
      const project_idx = state.data.findIndex(project => project._id === state.selected_project_id);
      state.data[project_idx].steps.push(step_data);
    },
  },
  actions: {
    async get_roadmaps ({commit}) {
      try {
        const { data } = await axios.get(api.roadmaps);
        commit('SET_ROADMAPS_STATE', { key: 'data', value: data });
        commit('SET_ROADMAPS_STATE', { key: 'selected_project_id', value: data[0]._id });
      }
      catch (err) {
        console.log(err)
      }
    },
    async add_step_to_project ({state, commit}, step_data) {
      try {
        const project_id = state.selected_project_id;
        const { data } = await axios.put(`${api.roadmaps}/add-step/${project_id}`, step_data);
        commit('ADD_PROJECT_STEP', data);
        commit('SET_MODAL', false);
      }
      catch (err) {
        console.log(err)
      }
    },
    async update_step ({state, commit}, step_data) {
      try {
        const project_id = state.selected_project_id;
        const payload = {
          project_id,
          step_data
        };
        const { data } = await axios.put(`${api.roadmaps}/update-step`, payload);
        commit('UPDATE_STEP', { ...payload, step_data: data });
        commit('SET_MODAL', false);
      }
      catch (err) {
        console.log(err)
      }
    },
  },
  getters: {
    roadmaps_projects: (state) => {
      return state.data.map(o => ({ _id: o._id, name: o.project_name }))
    },
    project_steps: (state) => {
      return state.data.find(o => o._id === state.selected_project_id)?.steps || [];
    },
  }
}